<template>
  <div>
    <el-form ref="form" size="mini" :model="formData" :rules="rules">
      <div v-if="shipmentStatus === 'L'">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_customsNo') || '关单号'"
              prop="customsNo"
            >
              <el-input
                v-model.trim="formData.customsNo"
                :placeholder="
                  $l('INDEX.form_placeholder_customsNo') || '请输入关单号'
                "
                clearable
                :maxlength="50"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_deliveryDate') || '产装日期'"
              prop="deliveryDate"
            >
              <el-date-picker
                v-model="formData.deliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="
                  $l('INDEX.form_placeholder_deliveryDate') ||
                    '请选择实际产装日期'
                "
                style="width: 100%"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_bookingScm') || '订舱货代'"
              prop="bookingScmCode"
            >
              <dict-select
                v-model="formData.bookingScmCode"
                url="/master/common/dict/xzScmPartners"
                size="mini"
                :placeholder="
                  $l('INDEX.form_placeholder_bookingScm') || '请选择订舱货代'
                "
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_customsBrokerScmCode') || '报关货代'"
              prop="customsBrokerScmCode"
            >
              <dict-select
                v-model="formData.customsBrokerScmCode"
                url="/master/common/dict/xzScmPartners"
                size="mini"
                :placeholder="
                  $l('INDEX.form_placeholder_customsBrokerScm') ||
                    '请选择报关货代'
                "
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.form_transitScm') || '运输公司'"
              prop="transitScmCode"
            >
              <dict-select
                v-model="formData.transitScmCode"
                url="/master/common/dict/xzScmPartners"
                size="mini"
                :placeholder="
                  $l('INDEX.form_placeholder_transitScm') || '请选择运输公司'
                "
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="shipmentStatus === 'C'">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_domesticShipperCode') || '境内发货人'"
              prop="domesticShipperCode"
            >
              <dict-select
                url="/factory/shipment/customer/select"
                v-model="formData.domesticShipperCode"
                :body="shipperParams"
                :placeholder="
                  $l('INDEX.form_placeholder_domesticShipperCode') ||
                    '请选择境内发货人'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_overseasConsigneeCode') || '境外收货人'"
              prop="overseasConsigneeCode"
            >
              <dict-select
                url="/factory/shipment/customer/select"
                v-model="formData.overseasConsigneeCode"
                :body="consigneeParams"
                :placeholder="
                  $l('INDEX.form_placeholder_overseasConsigneeCode') ||
                    '请选择境外收货人'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-if="shipmentStatus === 'S'">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('INDEX.form_closingDate') || '开船日期'" prop="closingDate">
              <el-date-picker
                v-model="formData.closingDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="
                  $l('INDEX.form_placeholder_closingDate') || '请选择开船日期'
                "
                style="width: 100%"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_cfdDate') || '提交清关文件日期'"
              prop="cfdDate"
            >
              <el-date-picker
                v-model="formData.cfdDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="
                  $l('INDEX.form_placeholder_cfdDate') ||
                    '请选择提交清关文件日期'
                "
                style="width: 100%"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_pfdDate') || '提交付款文件日期'"
              prop="pfdDate"
            >
              <el-date-picker
                v-model="formData.pfdDate"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="
                  $l('INDEX.form_placeholder_pfdDate') ||
                    '请选择提交付款文件日期'
                "
                style="width: 100%"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_shipperCode') || '发货人'"
              prop="shipperCode"
            >
              <dict-select
                url="/factory/shipment/customer/select"
                v-model="formData.shipperCode"
                :body="shipperParams"
                :placeholder="
                  $l('INDEX.form_placeholder_shipperCode') || '请选择发货人'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.form_consigneeCode') || '收货人'" prop="consigneeCode">
              <dict-select
                url="/factory/shipment/customer/select"
                v-model="formData.consigneeCode"
                :body="consigneeParams"
                :placeholder="
                  $l('INDEX.form_placeholder_consigneeCode') || '请选择收货人'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small"
          >{{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: {},
  props: {
    shipmentCode: { type: String, default: '' },
    shipmentBookingCodeList: { type: Array, default: () => [] },
    shipmentStatus: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      shipmentTypeParams: { dictType: 'shipmentType' },
      quotedMethodParams: { dictType: 'quotedMethod' },
      formData: {},
      backDialogVisible: false,
      rules: {
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_deliveryDate') ||
              '请输入产装日期',
            trigger: 'change',
          },
        ],
        bookingScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_bookingScm') || '请选择订舱货代',
            trigger: 'change',
          },
        ],
        customsBrokerScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_customsBrokerScm') ||
              '请选择报关货代',
            trigger: 'change',
          },
        ],
        transitScmCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_transitScm') || '请选择运输公司',
            trigger: 'change',
          },
        ],
        domesticShipperCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_domesticShipperCode') ||
              '请选择境内发货人',
            trigger: 'change',
          },
        ],
        overseasConsigneeCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_overseasConsigneeCode') ||
              '请选择境外收货人',
            trigger: 'change',
          },
        ],
        shipperCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_shipperCode') || '请选择发货人',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('INDEX.sample_tips_select_quotation_method') ||
              '请选择报价方式',
            trigger: 'blur',
          },
        ],
        closingDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_closingDate') || '请选择开船日期',
            trigger: 'change',
          },
        ],
        cfdDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_cfdDate') || '请选择提交清关文件日期',
            trigger: 'change',
          },
        ],
        pfdDate: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_pfdDate') || '请选择提交付款文件日期',
            trigger: 'change',
          },
        ],
        consigneeCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_placeholder_consigneeCode') || '请选择收货人',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    consigneeParams() {
      return { shipmentType: 'C', custCode: this.custCode }
    },
    shipperParams() {
      return { shipmentType: 'S', custCode: this.custCode }
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      const params = {
        ...this.formData,
        shipmentCode: this.shipmentCode,
        shipmentBookingCodeList: this.shipmentBookingCodeList,
      }
      this.loadingOpen()
      this.$api
        .shipmentBookingBatchEditApi(params)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
